const es: Record<string, string> = {
  // ── Navigation sections ──────────────────────────────────────────────────
  'nav.section.agentic':      'Agentic',
  'nav.section.knowledge':    'Conocimiento',
  'nav.section.tools':        'Herramientas',
  'nav.section.settings':     'Configuración',
  'nav.section.organization': 'Organización',

  // ── Navigation items ─────────────────────────────────────────────────────
  'nav.agents':       'Agentes',
  'nav.connectors':   'Conectores',
  'nav.marketplace':  'Marketplace',
  'nav.brain':        'Brain',
  'nav.playground':   'Playground',
  'nav.roadmap':      'Roadmap',
  'nav.docs':         'Documentación',
  'nav.apiDocs':      'API Reference',
  'nav.changelog':    'Changelog',
  'nav.organization': 'Organización',
  'nav.tokens':       'Tokens LLM',
  'nav.mcps':         'MCPs',

  // ── User menu ────────────────────────────────────────────────────────────
  'user.menu.settings':     'Configuración',
  'user.menu.organization': 'Administrar Organización',
  'user.menu.logout':       'Cerrar sesión',
  'user.newAgent':          'Nuevo agente',

  // ── Common actions ───────────────────────────────────────────────────────
  'common.save':      'Guardar',
  'common.cancel':    'Cancelar',
  'common.delete':    'Eliminar',
  'common.create':    'Crear',
  'common.edit':      'Editar',
  'common.preview':   'Vista previa',
  'common.reload':    'Recargar',
  'common.loading':   'Cargando...',
  'common.error':     'Error',
  'common.success':   'Éxito',
  'common.confirm':   'Confirmar',
  'common.search':    'Buscar',
  'common.filter':    'Filtrar',
  'common.export':    'Exportar',
  'common.import':    'Importar',
  'common.close':     'Cerrar',
  'common.back':      'Volver',
  'common.next':      'Siguiente',
  'common.previous':  'Anterior',
  'common.yes':       'Sí',
  'common.no':        'No',
  'common.unknown':   'Desconocido',

  // ── Brain ────────────────────────────────────────────────────────────────
  'brain.title':           'Cubicup Brain',
  'brain.newDept':         'Nuevo departamento',
  'brain.newDoc':          'Nuevo documento',
  'brain.reload':          'Recargar',
  'brain.emptyRepo':       'Repo vacío. Crea el primer departamento.',
  'brain.selectDoc':       'Selecciona un documento para empezar',
  'brain.selectDocHint':   'o crea un departamento con el panel lateral',
  'brain.unsaved':         'Sin guardar',
  'brain.saved':           'Guardado',
  'brain.deleteTitle':     '¿Eliminar este documento?',
  'brain.deleteWarning':   'Esta acción no se puede deshacer.',
  'brain.readmeNote':      'Se creará automáticamente un README.md en la carpeta.',
  'brain.selectDeptFirst': 'Selecciona un departamento primero',
  'brain.deptPlaceholder': 'ej: Recursos Humanos',
  'brain.docPlaceholder':  'ej: proceso-onboarding',
  'brain.deptCreated':     'Departamento creado',
  'brain.docCreated':      'Documento creado',
  'brain.docDeleted':      'Archivo eliminado',
  'brain.loadError':       'No se pudo cargar el Brain. Inténtalo de nuevo en unos minutos.',
  'brain.fileError':       'No se pudo cargar el archivo',
  'brain.saveError':       'Error al guardar',
  'brain.deleteError':     'Error al eliminar',
  'brain.deptError':       'Error al crear departamento',
  'brain.docError':        'Error al crear documento',

  // ── Agents ───────────────────────────────────────────────────────────────
  'agents.title':          'Agentes',
  'agents.newAgent':       'Nuevo agente',
  'agents.empty':          'No hay agentes todavía',
  'agents.emptyHint':      'Crea tu primer agente para empezar',
  'agents.delete':         'Eliminar agente',
  'agents.deleteConfirm':  '¿Eliminar este agente?',
  'agents.deleteWarning':  'Se eliminarán también todos sus nodos y flujos.',
  'agents.activate':       'Activar',
  'agents.activated':      'Agente activado',
  'agents.edit':           'Editar agente',
  'agents.created':        'Agente creado',
  'agents.updated':        'Agente actualizado',
  'agents.deleted':        'Agente eliminado',

  // ── Builder ──────────────────────────────────────────────────────────────
  'builder.flow':          'Flujo',
  'builder.executions':    'Ejecuciones',
  'builder.ontologies':    'Ontologías',
  'builder.api':           'API',
  'builder.addNode':       'Añadir nodo',
  'builder.saveFlow':      'Guardar flujo',
  'builder.flowSaved':     'Flujo guardado',
  'builder.activate':      'Activar agente',

  // ── Marketplace ──────────────────────────────────────────────────────────
  'marketplace.title':     'Marketplace',
  'marketplace.subtitle':  'Agentes preconstruidos listos para usar',
  'marketplace.install':   'Instalar',
  'marketplace.installed': 'Instalado',

  // ── Connectors ───────────────────────────────────────────────────────────
  'connectors.title':      'Conectores',
  'connectors.subtitle':   'Conecta CubicOS con tus herramientas',
  'connectors.http':       'HTTP',
  'connectors.monday':     'Monday.com',
  'connectors.gdrive':     'Google Drive',
  'connectors.test':       'Probar conexión',
  'connectors.save':       'Guardar conector',

  // ── Playground ───────────────────────────────────────────────────────────
  'playground.title':      'Playground',
  'playground.subtitle':   'Prueba tus agentes en tiempo real',
  'playground.send':       'Enviar',
  'playground.clear':      'Limpiar',
  'playground.inputHint':  'Escribe un mensaje...',

  // ── Organization ─────────────────────────────────────────────────────────
  'org.title':             'Organización',
  'org.users':             'Usuarios y Equipos',
  'org.ui':                'Gestionar UI',
  'org.teams':             'Equipos',
  'org.members':           'Miembros',
  'org.addUser':           'Añadir usuario',
  'org.addTeam':           'Crear equipo',
  'org.role.admin':        'Administrador',
  'org.role.editor':       'Editor',
  'org.role.viewer':       'Visualizador',

  // ── Roles ────────────────────────────────────────────────────────────────
  'role.admin':   'Admin',
  'role.editor':  'Editor',
  'role.viewer':  'Viewer',

  // ── Login ────────────────────────────────────────────────────────────────
  'login.title':    'Bienvenido',
  'login.subtitle': 'Inicia sesión con tu cuenta de Google',
  'login.button':   'Continuar con Google',

  // ── Errors ───────────────────────────────────────────────────────────────
  'error.generic':    'Ha ocurrido un error inesperado',
  'error.notFound':   'Página no encontrada',
  'error.forbidden':  'No tienes permiso para ver esta página',
  'error.network':    'Error de red. Comprueba tu conexión.',

  // ── Footer ───────────────────────────────────────────────────────────────
  'footer.by':        'by',
};

export default es;
